/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AttachmentDownloadUrlQueryVariables = Types.Exact<{
  owner: Types.AttachmentOwnerInput;
}>;


export type AttachmentDownloadUrlQuery = { attachmentDownloadUrl: { __typename: 'AttachmentDownloadUrlResult', url: string, title: string, mimeType: string } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const AttachmentDownloadUrlDocument = gql`
    query AttachmentDownloadUrl($owner: AttachmentOwnerInput!) {
  attachmentDownloadUrl(owner: $owner) {
    ... on AttachmentDownloadUrlResult {
      url
      title
      mimeType
    }
  }
}
    `;

/**
 * __useAttachmentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useAttachmentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentDownloadUrlQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useAttachmentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables> & ({ variables: AttachmentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>(AttachmentDownloadUrlDocument, options);
      }
export function useAttachmentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>(AttachmentDownloadUrlDocument, options);
        }
export function useAttachmentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>(AttachmentDownloadUrlDocument, options);
        }
export type AttachmentDownloadUrlQueryHookResult = ReturnType<typeof useAttachmentDownloadUrlQuery>;
export type AttachmentDownloadUrlLazyQueryHookResult = ReturnType<typeof useAttachmentDownloadUrlLazyQuery>;
export type AttachmentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useAttachmentDownloadUrlSuspenseQuery>;
export type AttachmentDownloadUrlQueryResult = Apollo.QueryResult<AttachmentDownloadUrlQuery, AttachmentDownloadUrlQueryVariables>;